var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_vm._v(_vm._s(_vm.url))])
}
var staticRenderFns = []

export { render, staticRenderFns }